<script lang="ts">
  import { preventDefault } from 'svelte/legacy';

  import { openChat } from "../../helpers/chat";
  import Card from "../atoms/Card.svelte";
  import Heading from "../atoms/Heading.svelte";
</script>

<Card bg="bg-Yellow">
  <Heading variant="secondary">
    Något gick fel vid signeringen med bankID.<br />
  </Heading>
  <span class={"text-Neutral900"}>
    Behöver du hjälp?
    <button type="button" onclick={preventDefault(openChat)} class={"font-bold hover:underline"}>
      Chatta
    </button>
    med oss eller ring oss på telefonnummer
    <a class={"font-bold"} href="tel:+46910772550">0910-77 25 50</a> så hjälper vi dig.
  </span>
</Card>
